export default __webpack_public_path__ + "static/hr-31f08719a38fb7c540e92643630f30ef.svg";